import React, { ReactElement } from "react";
import classnames from "classnames";
import _ from "lodash";
import { FormattedMessage } from "react-intl";
import { IClientContact } from "../../../services/WedApi/Models/ClientContact";
import Initials, { InitialsUserType } from "../components/Initials/Initials";
import Title from "../components/Title/Title";
import WedDate from "../../formatter/WedDate";
import "./ClientContactTile.scss";
import "../tile.scss";
import PhoneNumber from "../components/PhoneNumber/PhoneNumber";

interface PropsInterface {
    clientId: number;
    clientContact: IClientContact;
    selected?: boolean;
    onClick?: () => void;
    onDoubleClick?: () => void;
    actionButton?: ReactElement;
    disableHover?: boolean;
    withInitialsColor?: boolean;
}

interface StateInterface {
    previewImages: string[];
    isHover: boolean;
}

class ClientContactTile extends React.Component<PropsInterface, StateInterface> {
    private readonly EXCLUDE_PROPS_WHEN_UPDATING: string[] = ["onClick", "key", "get", "actionButton"];

    constructor(props: PropsInterface) {
        super(props);
        this.state = {
            previewImages: [],
            isHover: false,
        };
        this.onClick = this.onClick.bind(this);
        this.onDoubleClick = this.onDoubleClick.bind(this);
    }

    shouldComponentUpdate(nextProps: PropsInterface, nextState: StateInterface): boolean {
        return (
            !_.isEqual(_.omit(nextProps, this.EXCLUDE_PROPS_WHEN_UPDATING), _.omit(this.props, this.EXCLUDE_PROPS_WHEN_UPDATING)) ||
            !_.isEqual(nextState, this.state)
        );
    }

    onClick() {
        this.props.onClick && this.props.onClick();
    }

    onDoubleClick() {
        this.props.onDoubleClick && this.props.onDoubleClick();
    }

    render() {
        const { clientContact, selected, disableHover, actionButton, withInitialsColor } = this.props;

        return (
            <div
                className={classnames("tile client-contact-tile", {
                    "tile--active": selected,
                    "tile--disable-hover": disableHover,
                })}
                onMouseEnter={
                    disableHover
                        ? undefined
                        : () => {
                              this.setState({ isHover: true });
                          }
                }
            >
                {this.state.isHover && actionButton}
                <div className="tile-container" onClick={this.onClick} onDoubleClick={this.onDoubleClick}>
                    <div className="client-contact-tile__header">
                        <div className="client-contact-tile__profile-image">
                            {clientContact.initials && (
                                <Initials userType={withInitialsColor ? InitialsUserType.EXTERNAL : undefined} title={clientContact.initials} />
                            )}
                        </div>
                        <div className="client-contact-tile__profile-info">
                            <div className="client-contact-tile__profile-info-name">
                                <Title title={clientContact.name} />
                            </div>
                            {clientContact.position && (
                                <div className="client-contact-tile__profile-info-position">
                                    <span>{clientContact.position}</span>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="client-contact-tile--extra-info">
                        {clientContact.email && (
                            <div className="client-contact-tile__label-value">
                                <div className="client-contact-tile__label-value-label">
                                    <FormattedMessage id="app.ClientContactTile.email" />
                                </div>
                                <div className="client-contact-tile__label-value-value">{clientContact.email}</div>
                            </div>
                        )}
                        {clientContact.phone && (
                            <div className="client-contact-tile__label-value">
                                <div className="client-contact-tile__label-value-label">
                                    <FormattedMessage id="app.ClientContactTile.phone" />
                                </div>
                                <div className="client-contact-tile__label-value-value">
                                    <PhoneNumber phone={clientContact.phone} cCode={clientContact.cCode} />
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="client-contact-tile__details">
                        <FormattedMessage id={"app.tile.added"} />
                        <span className="client-contact-tile__date">{clientContact.created && <WedDate date={clientContact.created} />}</span>
                        <FormattedMessage id={"app.global.by"} />
                        <span className="client-contact-tile__user">{`${clientContact.createdBy?.firstName} ${clientContact.createdBy?.lastName}`}</span>
                    </div>
                    <div className="client-contact-tile__projects-info">
                        <FormattedMessage id={"app.ClientContactTile.projects"} />
                        <span className="client-contact-tile__projects-info-value">
                            {clientContact.numOfActiveProjects}
                            <span>/</span>
                            {clientContact.numOfClosedProjects}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default ClientContactTile;
